module.exports = __webpack_public_path__ + "static/media/alert-warning-circle.e9b64260.svg";